import { BaseStore } from './baseStore'; // for some dumb reason, these have to be imported individually
import { RootStore } from './rootStore'; // for some dumb reason, these have to be imported individually
import {
  Role,
  RoleGroup,
  RoleGroupService,
  RoleService,
  TCreateRoleGroupRequest,
  TCreateRoleRequest,
  TUpdateRoleGroupRequest,
  TUpdateRoleRequest,
} from '@talon/web/lib/api';

export class RoleStore extends BaseStore {
  constructor(rootStore: RootStore) {
    super(rootStore);
  }

  /**
   * Roles
   */

  getRoleById = async (roleId: string) => {
    try {
      const { role } = await RoleService.getRole(roleId, 'costumes,props,performer');
      return role;
    } catch (e) {
      this.handleError(e);
    }
  };

  getRolesByScriptId = async (scriptId: string) => {
    try {
      const { roles } = await RoleService.listRoles(undefined, scriptId, undefined, undefined, undefined, 'role_group');
      return roles;
    } catch (e) {
      this.handleError(e);
    }
  };

  getRolesByProjectId = async (projectId: string) => {
    try {
      const { roles } = await RoleService.listRoles(projectId, undefined, undefined, undefined, undefined, 'role_group,props,costumes,performer');
      return roles;
    } catch (e) {
      this.handleError(e);
    }
  };

  createRole = async ({ name, type, performerType, projectId }: TCreateRoleRequest) => {
    try {
      const { role } = await RoleService.createRole({ name, type, performerType, projectId });
      return role;
    } catch (e) {
      this.handleError(e);
    }
  };

  updateRole = async (role: Role, groupId?: string) => {
    const updateRequest: TUpdateRoleRequest = {
      ...role,
      performerType: role.performer_type,
      scriptId: role.script?.id,
      roleGroupId: groupId || role.role_group?.id,
      sessionActivityIds: role.session_activities?.map((sa) => sa.id),
      allowanceIds: role.allowances?.map((a) => a.id),
      costumeIds: role.costumes?.map((c) => c.id),
      propIds: role.props?.map((p) => p.id),
      feeIds: role.fees?.map((f) => f.id),
      tagsIds: role.tags?.map((t) => t.id),
      usageIds: role.usages?.map((u) => u.id),
      roleActivityIds: role.role_activities?.map((ra) => ra.id),
    };
    if (!role.id) return;
    try {
      const { role: updatedRole } = await RoleService.updateRole(role.id, updateRequest);
      return updatedRole;
    } catch (e) {
      this.handleError(e);
    }
  };

  deleteRole = async (roleId: string) => {
    try {
      await RoleService.deleteRole(roleId);
      return true;
    } catch (e) {
      this.handleError(e);
      return false;
    }
  };

  /**
   * Role Groups
   */

  getRoleGroupsByScriptId = async (scriptId: string) => {
    try {
      const { roleGroups } = await RoleGroupService.listRoleGroups(undefined, scriptId, undefined, undefined, undefined, 'roles');
      return roleGroups;
    } catch (e) {
      this.handleError(e);
    }
  };

  getRoleGroupsByProjectId = async (projectId: string) => {
    try {
      const { roleGroups } = await RoleGroupService.listRoleGroups(projectId, undefined, undefined, undefined, undefined, 'roles');
      return roleGroups;
    } catch (e) {
      this.handleError(e);
    }
  };

  createRoleGroup = async ({ name, roleIds, scriptId, projectId, sessionActivityIds }: TCreateRoleGroupRequest) => {
    try {
      const { roleGroup } = await RoleGroupService.createRoleGroup({
        name,
        scriptId,
        roleIds,
        projectId,
        sessionActivityIds,
      });
      return roleGroup;
    } catch (e) {
      this.handleError(e);
    }
  };

  updateRoleGroup = async (roleGroup: RoleGroup) => {
    const updateRequest: TUpdateRoleGroupRequest = {
      ...roleGroup,
      scriptId: roleGroup.script?.id,
      roleIds: roleGroup.roles?.map((r) => r.id),
      sessionActivityIds: roleGroup.session_activities?.map((sa) => sa.id),
    };
    try {
      const { roleGroup: updatedRoleGroup } = await RoleGroupService.updateRoleGroup(roleGroup.id, updateRequest);
      return updatedRoleGroup;
    } catch (e) {
      this.handleError(e);
    }
  };

  deleteRoleGroup = async (roleGroupId: string) => {
    try {
      await RoleGroupService.deleteRoleGroup(roleGroupId);
      return true;
    } catch (e) {
      this.handleError(e);
      return false;
    }
  };
}
